export default function isAbsoluteUrl(url: string) {
    return /^(?:[a-z]+:)?\/\//i.test(url);
}
